import { ChartData } from 'chart.js';
import { sumArrays } from 'services/utils/sumArrays';

type AddDataArgs = {
  label: string;
  backgroundColor: string;
  showLine: boolean;
  fill: boolean;
  order: number;
};
export class DatasetBuilder {
  private datasets: ChartData<'line', number[], string>['datasets'] = [];
  private nextArray: number[] = [];
  private arrayToDisplay: number[] = [];
  public maxNumb = 0;
  constructor(private filterByPeriod: (_: number, i: number) => boolean) {}

  addData(incomingData: number[], addDataArgs: AddDataArgs) {
    if (incomingData.length === 0) {
      return this;
    }
    this.nextArray = sumArrays(incomingData, this.nextArray);
    this.maxNumb = Math.max(...this.nextArray);

    this.datasets.push(this.createDataset(this.nextArray.filter(this.filterByPeriod), addDataArgs));
    return this;
  }

  build() {
    return this.datasets;
  }

  private createDataset(data: number[], { backgroundColor, fill, label, order, showLine }: AddDataArgs) {
    return {
      data,
      label,
      backgroundColor,
      showLine,
      fill,
      order,
    };
  }
}
